import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpDialogComponent } from './help-dialog/help-dialog/help-dialog.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-help-guide',
  templateUrl: './help-guide.component.html',
  styleUrls: ['./help-guide.component.scss']
})
export class HelpGuideComponent{
    bucketUrlGifUserGuide: string;
    showHelpButton = false;
    currentGif = '';
    currentDescription = '';
    helpContent!: { [key: string]: { gifUrl: string; description: string } };

    constructor(private router: Router, private dialog: MatDialog) {
        this.bucketUrlGifUserGuide = environment.bucketUrlGifUserGuide;

        this.helpContent = {
            '/home': {
                gifUrl: `${this.bucketUrlGifUserGuide}home-find-grids.gif`,
                description: 'help.home'
            },
            '/brands': {
                gifUrl: `${this.bucketUrlGifUserGuide}genre-filter.gif`,
                description: 'help.brands'
            },
            '/monthly': {
                gifUrl: `${this.bucketUrlGifUserGuide}monthly-download-grids.gif`,
                description: 'help.monthly'
            },
            '/epg/ancine': {
                gifUrl: `${this.bucketUrlGifUserGuide}ancine-download.gif`,
                description: 'help.ancine'
            },
            '/epg/networks': {
                gifUrl: `${this.bucketUrlGifUserGuide}brands-download-grids.gif`,
                description: 'help.network'
            }
        };

        this.router.events.subscribe(() => {
            this.checkRoute();
        });
    }

    checkRoute(): void {
        const currentPath = this.router.url;
        if (this.helpContent[currentPath]) {
            this.showHelpButton = true;
            this.currentGif = this.helpContent[currentPath].gifUrl;
            this.currentDescription = this.helpContent[currentPath].description;
        } else {
            this.showHelpButton = false;
        }
    }

    openHelpDialog(): void {
        this.dialog.open(HelpDialogComponent, {
            data: {
                gifUrl: this.currentGif,
                description: this.currentDescription
            },
            position: { bottom: '40px', right: '40px' },
            width: '700px',
            height: '400px'
        });
    }
}

